<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C5.93618 1 1 5.93618 1 12C1 18.0638 5.93618 23 12 23C18.0638 23 23 18.0638 23 12C23 5.93618 18.0638 1 12 1ZM12 2.57538C14.4432 2.57538 16.6764 3.50955 18.3513 5.04623C18.0693 4.99095 17.7874 5.00201 17.5111 5.09598C16.7482 5.36131 16.096 6.46683 16.5769 7.39548C16.798 7.82111 17.2402 8.42915 17.7211 9.06482C18.0307 9.4794 18.705 10.9829 18.1246 13.194C17.7156 14.7583 16.8588 17.4503 16.8588 17.4503L13.4372 7.49498H14.5151C14.7362 7.49498 14.9131 7.31809 14.9131 7.09699C14.9131 6.87588 14.7362 6.699 14.5151 6.699H9.28593C9.06482 6.699 8.88794 6.87588 8.88794 7.09699C8.88794 7.31809 9.06482 7.49498 9.28593 7.49498H10.1869L11.7513 11.5688L9.72261 17.6216L6.31759 7.49498H7.39548C7.61658 7.49498 7.79347 7.31809 7.79347 7.09699C7.79347 6.87588 7.61658 6.699 7.39548 6.699H4.21156C5.91407 4.21156 8.77186 2.57538 12 2.57538ZM2.57538 12C2.57538 10.6568 2.85729 9.3799 3.36583 8.22462L7.90402 20.4849C4.75327 18.9593 2.57538 15.7312 2.57538 12ZM9.26382 21.0156L12.2045 12.8734L15.1508 20.8829C14.1668 21.2312 13.1055 21.4246 12.0055 21.4246C11.0492 21.4246 10.1317 21.2809 9.26382 21.0156ZM16.9804 19.9985C17.5719 18.2573 19.6171 12.1824 20.004 10.9774C20.3688 9.84422 20.6618 9.1809 20.6397 8.24121C21.1427 9.39648 21.4246 10.6678 21.4246 12C21.4246 15.3663 19.6447 18.3291 16.9804 19.9985Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
